export default __webpack_public_path__ + "static/media/p-minus-0.383eb99a.svg";